var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import EventBus from './EventBus';
import cookieStorage, { CookieStorage } from '../CookieStorage';
var EventSubscription = /** @class */ (function (_super) {
    __extends(EventSubscription, _super);
    function EventSubscription(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            value: props.defaultValue,
            emit: _this.emit.bind(_this),
        };
        _this.eventBus = new EventBus();
        _this.handleEvent = _this.handleEvent.bind(_this);
        return _this;
    }
    EventSubscription.prototype.emit = function (data) {
        this.eventBus.emit(this.props.eventName, data);
    };
    EventSubscription.prototype.handleEvent = function (event) {
        var _this = this;
        this.setState(function (_a) {
            var value = _a.value;
            var newValue = _this.props.eventReducer(event);
            return value !== newValue ? { value: newValue } : null;
        });
    };
    EventSubscription.prototype.componentDidMount = function () {
        this.eventBus.on(this.props.eventName, this.handleEvent);
    };
    EventSubscription.prototype.componentWillUnmount = function () {
        this.eventBus.off(this.props.eventName, this.handleEvent);
    };
    EventSubscription.prototype.render = function () {
        return this.props.children(this.state);
    };
    EventSubscription.propTypes = {
        /** Default value for the subscribed event */
        defaultValue: PropTypes.any,
        /** Event name */
        eventName: PropTypes.string.isRequired,
        /** Allows to modify event before setting it to the subscription state */
        eventReducer: PropTypes.func,
        /** Render prop that will get access to event value and event emitter */
        children: PropTypes.func.isRequired,
    };
    EventSubscription.defaultProps = {
        defaultValue: null,
        eventReducer: function (value) { return value; },
    };
    return EventSubscription;
}(React.Component));
export var SideNavSubscription = function (props) { return (React.createElement(EventSubscription, { defaultValue: false, eventName: EventBus.EVENTS.ToggleSideNav }, props.children)); };
SideNavSubscription.propTypes = {
    /** Render prop that will get access to event value and event emitter */
    children: PropTypes.func.isRequired,
};
export var WishlistSubscription = function (props) { return (React.createElement(EventSubscription, { defaultValue: cookieStorage.getWishlistCount(), eventName: EventBus.EVENTS.WishlistCounterUpdate, eventReducer: function (_a) {
        var wishlistItemsCount = (_a === void 0 ? {} : _a).wishlistItemsCount;
        return CookieStorage.normalizeNumber(wishlistItemsCount);
    } }, props.children)); };
WishlistSubscription.propTypes = {
    /** Render prop that will get access to event value and event emitter */
    children: PropTypes.func.isRequired,
};
export var CartSubscription = function (props) { return (React.createElement(EventSubscription, { defaultValue: cookieStorage.getCartCount(), eventName: EventBus.EVENTS.CartCounterUpdate }, props.children)); };
CartSubscription.propTypes = {
    /** Render prop that will get access to event value and event emitter */
    children: PropTypes.func.isRequired,
};
export var CartOverviewUpdateSubscription = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(EventSubscription, { defaultValue: props, eventName: EventBus.EVENTS.CartOverviewUpdate }, children));
};
CartOverviewUpdateSubscription.propTypes = {
    /** Render prop that will get access to event value and event emitter */
    children: PropTypes.func.isRequired,
};
export var DisclaimerSubscription = function (props) { return (React.createElement(EventSubscription, { defaultValue: { open: false }, eventName: EventBus.EVENTS.ToggleDisclaimer }, props.children)); };
DisclaimerSubscription.propTypes = {
    /** Render prop that will get access to event value and event emitter */
    children: PropTypes.func.isRequired,
};
export default EventSubscription;
